import { render, staticRenderFns } from "./NudgingConfig.vue?vue&type=template&id=77bf157c&scoped=true&"
import script from "./NudgingConfig.vue?vue&type=script&lang=js&"
export * from "./NudgingConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bf157c",
  null
  
)

export default component.exports